import classNames from 'classnames';
import { DetailedHTMLProps, LabelHTMLAttributes } from 'react';

export type LabelProps = DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> & {
  required?: boolean;
  append?: React.ReactNode;
  size?: 'small' | 'medium';
};

/**
 * Prestyled label element
 */
export function Label({ className, children, required, append, size = 'medium', ...otherProps }: LabelProps) {
  return (
    <label
      {...otherProps}
      className={classNames(
        'flex flex-row items-end font-medium text-white',
        size === 'medium' && 'text-sm',
        size === 'small' && 'text-xs',
        className,
      )}
    >
      <span className="flex-1">
        {children}
        {required && <span className="whitespace-nowrap color-inherit font-normal ml-[2px]">*</span>}
      </span>
      {append}
    </label>
  );
}

export default Label;
